import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Header, Segment, Button, Dropdown, Grid} from 'semantic-ui-react';
import REST from 'go/requests/rest';

const emptyStr = '';

export class Workflow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }

  componentDidMount() {
    this.initializeState();
  }

  restartExternalTasks = (data) => {
    return REST.camunda
      .restartExternalTasks(this.externalTaskPayload(data))
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  externalTaskPayload(data) {
    return {
      retries: 1,
      externalTaskIds: data.taskId.split(','),
    };
  }

  restartActivity = (data) => {
    return REST.camunda
      .restartActivity(data.processName, this.activityPayload(data))
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  activityPayload(data) {
    return {
      instructions: [
        {
          type: 'startBeforeActivity',
          activityId: data.activityId,
        },
      ],
      processInstanceIds: data.processId.split(','),
      skipCustomListeners: true,
      withoutBusinessKey: true,
    };
  }

  logAction = (action, data) => {
    let payload = {
      userId: this.props.currUserEmail,
      action: 'workflow|' + action,
      payload: data,
    };
    return REST.admin
      .logAction(payload)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  handleChange = (e) => {
    e.preventDefault();
    const {name, value} = e.target;
    this.setState({[name]: value});
    this.canSubmit();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let data = this.state;
    if (this.state.taskType === 'externalTask') {
      this.restartExternalTasks(data).then((res) => {
        this.logAction('restartExternalTasks', this.externalTaskPayload(data));
        this.initializeState();
      });
    } else if (this.state.taskType === 'activity') {
      this.restartActivity(data).then((res) => {
        this.logAction('restartActivity', this.activityPayload(data));
        this.initializeState();
      });
    }
  };

  handleSubmitModal = () => {
    this.setState({
      openModal: true,
    });
  };

  renderSubmitModal() {
    return (
      <FemaGoModal
        title={'Confirm'}
        open={this.state.openModal}
        confirmAction={this.handleSubmit}
        cancelAction={() => {
          this.setState({
            openModal: false,
          });
        }}
        size="tiny"
      >
        Please confirm that you want to restart workflow task
      </FemaGoModal>
    );
  }

  canSubmit() {
    if (this.state.taskType === 'externalTask' && !_.isEmpty(_.trim(this.state.taskId))) {
      this.setState({canSubmit: true});
    } else if (
      this.state.taskType === 'activity' &&
      !_.isEmpty(_.trim(this.state.processId)) &&
      !_.isEmpty(_.trim(this.state.processName)) &&
      !_.isEmpty(_.trim(this.state.activityId))
    ) {
      this.setState({canSubmit: true});
    } else this.setState({canSubmit: false});
  }

  initializeState() {
    this.setState({
      error: false,
      canSubmit: false,
      openModal: false,
      processId: emptyStr,
      processName: emptyStr,
      taskId: emptyStr,
      activityId: emptyStr,
      taskType: emptyStr,
    });
  }

  renderExternalTask() {
    return (
      <React.Fragment>
        <FemaGoTable FemaGoTable type="entry" summary="workflowExternalTask">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Task id(s)</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>
            <FemaGoTable.Row>
              <FemaGoTable.InputCell
                key={`{taskId}`}
                title="Task id"
                id="taskId"
                name="taskId"
                value={this.state.taskId}
                handleChange={this.handleChange}
                handleBlur={this.handleChange}
                maxLength={501}
              />
            </FemaGoTable.Row>
          </FemaGoTable.Body>
        </FemaGoTable>
      </React.Fragment>
    );
  }

  renderActivity() {
    return (
      <React.Fragment>
        <FemaGoTable FemaGoTable type="entry" summary="workflowActivity">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Process instance id</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Process definition id</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Activity id</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>
            <FemaGoTable.Row>
              <FemaGoTable.InputCell
                key={`{processId}`}
                title="Process instance id"
                id="processId"
                name="processId"
                value={this.state.processId}
                handleChange={this.handleChange}
                handleBlur={this.handleChange}
                maxLength={501}
              />
              <FemaGoTable.InputCell
                key={`{processName}`}
                title="Process name"
                id="processName"
                name="processName"
                value={this.state.processName}
                handleChange={this.handleChange}
                handleBlur={this.handleChange}
                maxLength={501}
              />
              <FemaGoTable.InputCell
                key={`{activityId}`}
                title="Activity id"
                id="activityId"
                name="activityId"
                value={this.state.activityId}
                handleChange={this.handleChange}
                handleBlur={this.handleChange}
                maxLength={501}
              />
            </FemaGoTable.Row>
          </FemaGoTable.Body>
        </FemaGoTable>
      </React.Fragment>
    );
  }

  renderWorkflow() {
    let actionOptions = [
      {
        key: 'externalTask',
        text: 'External task',
        value: 'externalTask',
      },
      {
        key: 'activity',
        text: 'Activity',
        value: 'activity',
      },
    ];

    return (
      <React.Fragment>
        <Segment padded>
          <Grid verticalAlign="bottom">
            <Grid.Row>
              <Grid.Column width={8}>
                <Header as="h3">{'Restart workflow task'}</Header>
              </Grid.Column>
              <Grid.Column width={3} textAlign="right" />
              <Grid.Column width={5} textAlign="right">
                <Button
                  primary
                  title="Submit"
                  id="submitBtn"
                  onClick={this.handleSubmitModal}
                  disabled={this.state.canSubmit ? false : true}
                >
                  Submit
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <FemaGoTable FemaGoTable type="entry" summary="workflow">
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                <FemaGoTable.HeaderCell>Task type</FemaGoTable.HeaderCell>
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              <FemaGoTable.Row>
                <FemaGoTable.TextCell>
                  <Dropdown
                    selectOnNavigation={false}
                    selectOnBlur={false}
                    placeholder="-Select-"
                    options={actionOptions}
                    onChange={(e, {name, value}) => {
                      this.setState({taskType: value});
                      this.handleChange(e);
                    }}
                    selection
                  />
                </FemaGoTable.TextCell>
              </FemaGoTable.Row>
            </FemaGoTable.Body>
          </FemaGoTable>
          {this.state.taskType === 'externalTask' && this.renderExternalTask()}
          {this.state.taskType === 'activity' && this.renderActivity()}
          {this.state.openModal && this.renderSubmitModal()}
        </Segment>
      </React.Fragment>
    );
  }

  render() {
    let {error} = this.state;
    return <React.Fragment>{!error && this.renderWorkflow()}</React.Fragment>;
  }
}

export const mapDispatchToProps = (dispatch) => ({});

export const mapStateToProps = (state) => {
  return {
    currUserEmail: state.profile.emailAdr,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Workflow);
